import { cloneElement } from 'react';

const ChooseWrapper = ({ wrapper, children }) => cloneElement(
  wrapper,
  null,
  children,
);

export default ChooseWrapper;
